import { useState, useEffect } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import { getRevenueTrends } from "../../../services/tenantUserAdminService";
import { TC } from "../../../tokens/text";
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip } from "recharts";

export default function RevenueTrendWidget({ tenantId }) {
  const [loading, setLoading] = useState(true);
  const [trend, setTrend] = useState([]);

  useEffect(() => {
    const demoMode = typeof window !== 'undefined' && (window.__LEDGERHUB_DEMO || new URLSearchParams(window.location.search).get('demo') === 'true');
    if (demoMode) {
      const now = new Date(); const pts = [];
      for (let m = 11; m >= 0; m--) {
        const d = new Date(now.getFullYear(), now.getMonth() - m, 1);
        pts.push({ date: d.toISOString().slice(0,10), amount: Math.round(8000 + Math.cos(m/2)*1200) });
      }
      setTrend(pts);
      setLoading(false);
      return;
    }
    if (!tenantId) return;
    setLoading(true);
    getRevenueTrends(tenantId)
      .then((res) => setTrend((res.points || []).map(p => ({ date: p.date, amount: Number(p.amount || 0) })) ))
      .catch(() => setTrend([]))
      .finally(() => setLoading(false));
  }, [tenantId]);

  if (loading) return <VuiBox display="flex" justifyContent="center" alignItems="center" height="100%"><CircularProgress size={24} /></VuiBox>;
  if (!trend.length) return <VuiBox p={2}><VuiTypography color="text">No revenue data available.</VuiTypography></VuiBox>;

  const mtd = trend.slice(-30).reduce((s, p) => s + p.amount, 0);
  const ytd = trend.reduce((s, p) => s + p.amount, 0);

  return (
    <VuiBox p={1} display="flex" flexDirection="column" gap={1} height="100%">
      <VuiBox display="flex" justifyContent="space-between" alignItems="center">
        <VuiTypography sx={{ color: TC.secondary }}>MTD Revenue</VuiTypography>
        <VuiTypography sx={{ color: TC.primary, fontWeight: 700 }}>£{mtd.toLocaleString()}</VuiTypography>
      </VuiBox>
      <VuiBox sx={{ flex: 1, minHeight: 0 }}>
        <ResponsiveContainer width="100%" height={120}>
          <LineChart data={trend} margin={{ top: 6, right: 8, left: 0, bottom: 0 }}>
            <XAxis dataKey="date" tickFormatter={(d)=>d.slice(0,7)} hide />
            <YAxis tickFormatter={(v)=>`£${Math.round(v)}`} width={60} />
            <Tooltip formatter={(v)=>`£${v}`} />
            <Line type="monotone" dataKey="amount" stroke="#4caf50" strokeWidth={2} dot={false} />
          </LineChart>
        </ResponsiveContainer>
      </VuiBox>
      <VuiBox display="flex" justifyContent="space-between">
        <VuiTypography sx={{ color: TC.secondary }}>YTD Revenue</VuiTypography>
        <VuiTypography sx={{ color: TC.primary, fontWeight: 700 }}>£{ytd.toLocaleString()}</VuiTypography>
      </VuiBox>
    </VuiBox>
  );
}

